import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-department-form',
  templateUrl: './department-form.component.html',
  styleUrls: ['./department-form.component.css']
})
export class DepartmentFormComponent implements OnInit {
  title="Add Department";
  data : any = {};
  formInvalid : boolean = false;
  d : any = {};

  dep_Id : number;
  mode : string;

  
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
  { 

  }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.dep_Id = params['dep_Id'];  
      this.mode =  params['mode'];   
        
        if(this.dep_Id > 0){
          this.GetDepartmentById(this.dep_Id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Department ";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Department ";
    }  
  }

  SaveDepartment(Department: NgForm){ 
    
    if(Department.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostDepartment(Department.value);    
            this.data.subscribe(
            (response) => {
              Department.reset();
              Department.resetForm();
              Department.form.markAsPristine();
              Department.form.markAsUntouched();        
              swal('Success!', 'Department Added Successfully .', 'success');
              this.router.navigate(['/home/Department']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetDepartmentById(dep_Id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetDepartmentById(dep_Id);
        this.data.subscribe(
          (response: any) => {
            this.d = response;        
                          
            document.getElementById('loader-spinner').style.display = "none";
          },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }
  UpdateDepartment(Department: NgForm) {  
    this.data = this.UserService.UpdateDepartment(Department.value,this.dep_Id);
   this.data.subscribe(
     (response) => {
      Department.reset();
      Department.resetForm();
      Department.form.markAsPristine();
      Department.form.markAsUntouched();           
                   
       swal('Success!', 'Department updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/Department']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.d.dep_Code='';
this.d.dep_Name='';
}




  

}




// WEBPACK FOOTER //
// ./src/app/masters/department/department-form/department-form.component.ts